module.exports = __webpack_public_path__ + "img/file-fill.6a6142db.svg";